var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sid-select"},[_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Message","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Error']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message-no-error::before`,"rule-name":"background-color"}})],1)]),_c('sid-font',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message`,"rule-name":"color"}})],1)])]},proxy:true},{key:"Error",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message-error::before`,"rule-name":"background-color"}})],1)]),_c('sid-font',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message-error`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message-error`,"rule-name":"font-size"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-message-error`,"rule-name":"color"}})],1)])]},proxy:true}])})],1),_c('SidbearSettingsGroup',{style:({margin: 0}),attrs:{"title":"Border & Radius","button-class":"!px-[16px]","content-class":"!py-[14px] !px-[16px]"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Focus', 'Error']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-iframe-container`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-iframe-container`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-iframe-container`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`${_vm.sidClass} .sq-card-wrapper .sq-card-iframe-container`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Focus",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-focus .sq-card-iframe-container::before`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-focus .sq-card-iframe-container::before`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-focus .sq-card-iframe-container::before`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`${_vm.sidClass} .sq-card-wrapper.sq-focus .sq-card-iframe-container::before`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Error",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between !gap-[20px]"},[_c('label',{staticClass:"w-full pb-0"},[_vm._v("Border Type")]),_c('sid-select',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-error .sq-card-iframe-container::before`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                },
                {
                  label: 'Dashed',
                  value: 'dashed'
                },
                {
                  label: 'Dotted',
                  value: 'dotted'
                },
                {
                  label: 'Double',
                  value: 'double'
                },
                {
                  label: 'Outset',
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-error .sq-card-iframe-container::before`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`${_vm.sidClass} .sq-card-wrapper.sq-error .sq-card-iframe-container::before`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`${_vm.sidClass} .sq-card-wrapper.sq-error .sq-card-iframe-container::before`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }